import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';
import { SystemEventTypesSchema } from './system-event-types-schema';

export const NewSystemEventSchema = oz.object({
  type: SystemEventTypesSchema,
  objectTypeId: ObjectIdSchema,
}).openapi('NewSystemEvent');

export type NewSystemEvent = oz.infer<typeof NewSystemEventSchema>;